import { SignIn } from "@clerk/nextjs";
import Link from "next/link";

import { SecondaryLayout } from "~/layouts";
import type { NextPageWithProps } from "~/types";

const SignInPage: NextPageWithProps = () => {
	return (
		<div className="flex w-full max-w-md flex-col items-center gap-8 rounded-xl border bg-white phablet:px-10 px-4 phablet:py-8 py-6 shadow shadow-slate-200 dark:bg-slate-800 dark:shadow-slate-950">
			<SignIn path="/sign-in" />

			<div className="flex flex-col gap-6">
				<p className="text-center">
					Don&apos;t have an account?{" "}
					<Link
						href="/sign-up"
						className="text-sky-600 hover:underline dark:text-sky-300"
					>
						Sign Up
					</Link>
				</p>

				<p className="flex gap-6 text-sm">
					<Link
						href="/terms-of-service"
						target="_blank"
						className="font-medium hover:underline"
					>
						Terms of Service
					</Link>{" "}
					<Link
						href="/privacy-policy"
						target="_blank"
						className="font-medium hover:underline"
					>
						Privacy Policy
					</Link>
				</p>
			</div>
		</div>
	);
};

SignInPage.Layout = SecondaryLayout;

export default SignInPage;
